export const PurchasedCourseStatus = {

    PAYMENT_WAIT:"در انتظار پرداخت",
    READY_TO_ACTIVE:"آماده فعال سازی",
    PROCESSING:"در حال انجام عملیات",
    ACTIVE:"فعال",
    EXPIRE:"منقضی",
    COMPLETE:"تکمیل",
    CANCEL:"لغو",
}
